export class PushNotification{
    id?: number;
    attributes?: {
        title?: string;
        description?: string;
        clientguid?: string;
        recordguid?: string;
        servicetype?: string;
        vendorguid?: string;
        createdAt?: string;
        userguids?: any;
    }
}